import axios from 'axios';

const API_KEY = process.env.REACT_APP_POLYGON_API_KEY;
if (!API_KEY) {
  console.error('REACT_APP_POLYGON_API_KEY is not set in the environment variables');
}

const BASE_URL = 'https://api.polygon.io/v3/reference/tickers';

const fetchStocksForExchange = async (exchange, limit) => {
  const stocks = [];
  const pageSize = 500;
  let url = `${BASE_URL}?type=CS&market=stocks&exchange=${exchange}&order=asc&limit=${pageSize}&active=true&apiKey=${API_KEY}`;

  console.log(`Starting to fetch stocks from ${exchange}. Limit: ${limit}`);

  while (stocks.length < limit) {
    console.log(`Fetching from ${exchange}. Current stock count: ${stocks.length}`);
    console.log(`URL: ${url}`);

    const response = await axios.get(url);
    const data = response.data;

    if (data.results) {
      const newStocks = data.results
        .filter(stock => stock.ticker && stock.name)
        .map(stock => ({
          symbol: stock.ticker,
          name: stock.name,
          exchange: stock.primary_exchange
        }));
      stocks.push(...newStocks);
      console.log(`Fetched ${newStocks.length} new stocks from ${exchange}. Total stocks for ${exchange}: ${stocks.length}`);
    } else {
      console.log(`No results in the current page for ${exchange}.`);
      break;
    }

    if (data.next_url) {
      const nextUrlParams = new URL(data.next_url).searchParams;
      const cursor = nextUrlParams.get('cursor');
      if (cursor) {
        url = `${BASE_URL}?cursor=${cursor}&apiKey=${API_KEY}`;
      } else {
        console.log(`No cursor found in next_url for ${exchange}. Stopping pagination.`);
        break;
      }
    } else {
      console.log(`No more pages to fetch for ${exchange}.`);
      break;
    }

    if (stocks.length >= limit) {
      break;
    }
  }

  return stocks;
};

export const fetchActiveStocks = async (limit = 1000) => {
  const exchanges = ['XNAS', 'XNYS', 'XASE', 'ARCX'];

  console.log(`Starting to fetch active stocks from NASDAQ, NYSE, AMEX, and NYSE Arca. Limit per exchange: ${limit}`);

  try {
    const stockPromises = exchanges.map(exchange => fetchStocksForExchange(exchange, limit));
    const stocksFromAllExchanges = await Promise.all(stockPromises);

    const allStocks = stocksFromAllExchanges.flat();
    
    // Remove duplicates
    const uniqueStocks = Array.from(new Map(allStocks.map(stock => [stock.symbol, stock])).values());
    
    console.log(`Total unique stocks fetched: ${uniqueStocks.length}`);

    const finalStocks = uniqueStocks.slice(0, limit);

    console.log(`Returning ${finalStocks.length} unique active stocks from NASDAQ, NYSE, AMEX, and NYSE Arca.`);
    console.log('Sample of returned stocks:', finalStocks.slice(0, 5));

    return finalStocks;
  } catch (error) {
    console.error('Error fetching active stocks:', error);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
      console.error('Response headers:', error.response.headers);
    } else if (error.request) {
      console.error('No response received:', error.request);
    } else {
      console.error('Error message:', error.message);
    }
    return [];
  }
};
